import React from 'react';
import { Col, Row } from 'reactstrap';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';
import { Typography } from '@mui/material';
import { translate, Translate, Storage } from 'react-jhipster';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export const FormsTableSection = ({
  responsiveFont,
  quotationEntity,
  getSellColor,
  canShowInvoiceSection = false,
  canShowLocalFormSection = false,
  canShowPoaFormSection = false,
}) => {
  // Don't render if no section should be shown
  if (!canShowInvoiceSection && !canShowLocalFormSection && !canShowPoaFormSection) {
    return null;
  }

  const handleInvoiceClick = () => {
    const url = `/quotation/invoice-template/${quotationEntity.id}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handleLocalFormClick = () => {
    const url = `/quotation/local-form-template/${quotationEntity.id}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const handlePoaFormClick = () => {
    const url = `/quotation/poa-form-template/${quotationEntity.id}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  // Prepare forms data
  const forms = [];

  if (canShowInvoiceSection) {
    forms.push({
      id: 1,
      name: translate('comexApp.quotation.invoiceHeading'),
      action: handleInvoiceClick,
      buttonLabel: translate('comexApp.quotation.invoiceBtnLabel'),
    });
  }

  if (canShowLocalFormSection) {
    forms.push({
      id: canShowInvoiceSection ? 2 : 1,
      name: translate('comexApp.quotation.localForm.localFormHeading'),
      action: handleLocalFormClick,
      buttonLabel: translate('comexApp.quotation.localForm.localFormBtnLabel'),
    });
  }

  if (canShowPoaFormSection) {
    forms.push({
      id: forms.length + 1,
      name: translate('comexApp.quotation.poaForm.poaFormHeading'),
      action: handlePoaFormClick,
      buttonLabel: translate('comexApp.quotation.poaForm.poaFormBtnLabel'),
    });
  }

  return (
    <Row className="justify-content-center" style={{ marginTop: '12px' }}>
      <Col md="8" lg="6" className="round-border mt-1" style={{ padding: '28px 42px 28px 42px' }}>
        <Row className="mb-3">
          <Col xs={12}>
            <Typography variant="h6" component="div">
              <strong>{translate('comexApp.quotation.formsHeading')}</strong>
            </Typography>
          </Col>
        </Row>

        {/* Forms Table */}
        <TableContainer component={Paper} elevation={0} className="mt-3" sx={{ border: '1px solid #eee' }}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                <TableCell width="8%">{translate('comexApp.quotation.index')}</TableCell>
                <TableCell width="62%">{translate('comexApp.quotation.formName')}</TableCell>
                <TableCell width="30%" align="center">
                  {translate('comexApp.quotation.actions')}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {forms.map(form => (
                <TableRow key={form.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell>{form.id}</TableCell>
                  <TableCell>{form.name}</TableCell>
                  <TableCell align="center">
                    <IconButton size="small" onClick={form.action} color="primary" title={form.name}>
                      <FontAwesomeIcon icon={faDownload} size="sm" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Col>
    </Row>
  );
};
